
import './index.css';

function Metric({ handle, meta, domain, parentId, updateDomain }) {

  const emptyTask = () => {
    return { title: '', status: 'todo', dueDate: '', sortOrder: 0 };
  };

  const metricKeyFromLabel = (label) => {
    return label
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '_');
  };

  const emptyMetric = () => {
    return {
      metricLabel: '',
      metricKey: '',
      value: '',
      targetValue: '',
      unit: '',
      recordedOn: '',
      trend: 'flat',
      note: '',
    };
  };

  const addListItem = (key, emptyValueFactory) => {
    updateDomain((prev) => ({
      ...prev,
      [key]: [...(prev[key] || []), emptyValueFactory()],
    }));
  };

  const updateListItem = (key, index, field, value) => {
    updateDomain((prev) => {
      const nextItems = [...(prev[key] || [])];
      nextItems[index] = {
        ...(nextItems[index] || {}),
        [field]: value,
      };
      return { ...prev, [key]: nextItems };
    });
  };

  const removeListItem = (key, index) => {
    updateDomain((prev) => {
      const nextItems = [...(prev[key] || [])];
      nextItems.splice(index, 1);
      return { ...prev, [key]: nextItems };
    });
  };

  return (
    <section className="card-subsection">
      <div className="row-between">
        <h3 className="section-title">Measurable Success Factors</h3>
        <button className="button-secondary" type="button" onClick={() => addListItem('metrics', emptyMetric)}>
          Add Metric
        </button>
      </div>
      <div className="stack-sm">
        {domain.metrics?.map((item, index) => (
          <div className="inline-form-card wrap" key={item.id || `metric-${index}`}>
            <input
              placeholder="Metric label"
              value={item.metricLabel}
              onChange={(e) => {
                const metricLabel = e.target.value;
                updateListItem('metrics', index, 'metricLabel', metricLabel);
                if (!item.metricKey) {
                  updateListItem('metrics', index, 'metricKey', metricKeyFromLabel(metricLabel));
                }
              }}
            />
            <input
              placeholder="Metric key"
              value={item.metricKey}
              onChange={(e) => updateListItem('metrics', index, 'metricKey', e.target.value)}
            />
            <input
              type="number"
              step="0.01"
              placeholder="Value"
              value={item.value}
              onChange={(e) => updateListItem('metrics', index, 'value', e.target.value)}
            />
            <input
              type="number"
              step="0.01"
              placeholder="Target"
              value={item.targetValue}
              onChange={(e) => updateListItem('metrics', index, 'targetValue', e.target.value)}
            />
            <input
              placeholder="Unit"
              value={item.unit}
              onChange={(e) => updateListItem('metrics', index, 'unit', e.target.value)}
            />
            <input
              type="date"
              value={item.recordedOn}
              onChange={(e) => updateListItem('metrics', index, 'recordedOn', e.target.value)}
            />
            <select value={item.trend} onChange={(e) => updateListItem('metrics', index, 'trend', e.target.value)}>
              <option value="up">Up</option>
              <option value="down">Down</option>
              <option value="flat">Flat</option>
            </select>
            <input
              placeholder="Notes"
              value={item.note}
              onChange={(e) => updateListItem('metrics', index, 'note', e.target.value)}
            />
            <button className="button-danger" type="button" onClick={() => removeListItem('metrics', index, emptyMetric)}>
              Remove
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Metric;